import React, { useEffect, useState } from "react";
import { Chart } from "react-chartjs-2";
import { Chart as ChartJS, Tooltip, Legend, LinearScale } from "chart.js";
import {
  ChoroplethChart,
  ChoroplethController,
  ProjectionScale,
  ColorScale,
  GeoFeature,
} from "chartjs-chart-geo";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { geoMercator } from "d3-geo";
import PropTypes from "prop-types";

ChartJS.register(
  ChoroplethChart,
  ChoroplethController,
  ProjectionScale,
  ColorScale,
  GeoFeature,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels,
);

export default function MapaSP({ onCidadeClick }) {
  const [geojson, setGeojson] = useState(null);

  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/tbrugz/geodata-br/master/geojson/geojs-35-mun.json",
    )
      .then((res) => res.json())
      .then(setGeojson)
      .catch(console.error);
  }, []);

  if (!geojson) return <div>Carregando mapa...</div>;

  const regiaoSJBV = [
    "Divinolândia",
    "Aguaí",
    "Águas da Prata",
    "Caconde",
    "Casa Branca",
    "Espírito Santo do Pinhal",
    "Estiva Gerbi",
    "Itapira",
    "Itobi",
    "Mococa",
    "Mogi Guaçu",
    "Mogi Mirim",
    "Santa Cruz das Palmeiras",
    "Santo Antônio do Jardim",
    "São José do Rio Pardo",
    "São Sebastião da Grama",
    "Tambaú",
    "Tapiratiba",
    "Vargem Grande do Sul",
    "São João da Boa Vista",
  ];

  const projection = geoMercator().fitSize([900, 650], geojson);

  const data = {
    labels: geojson.features.map((d) => d.properties.name),
    datasets: [
      {
        outline: geojson,
        showOutline: true,
        data: geojson.features.map((d) => ({
          feature: d,
          value: regiaoSJBV.includes(d.properties.name) ? 1 : 0,
        })),
        borderColor: "#999",
        borderWidth: 0.5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    onClick: (event, elements, chart) => {
      if (!elements.length) {
        return;
      }

      const { index } = elements[0];
      const feature = chart.data.datasets[0].data[index].feature;
      const nomeCidade = feature.properties.name;

      if (regiaoSJBV.includes(nomeCidade)) {
        onCidadeClick?.(nomeCidade);
      }
    },

    plugins: {
      legend: { display: false },

      //  DESATIVA OS DATALABELS NO MAPA
      datalabels: {
        display: false,
      },

      tooltip: {
        callbacks: {
          label: (context) => {
            const nome = context.raw.feature.properties.name;
            return nome;
          },
        },
      },
    },

    scales: {
      projection: {
        axis: "x",
        projection,
      },
      color: {
        axis: "x",
        quantize: 2,
        interpolate: (t) => (t === 0 ? "#e0e0e0" : "#1f7a1f"),
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Chart
        type="choropleth"
        data={data}
        options={{
          ...options,
          maintainAspectRatio: false,
        }}
      />
    </div>
  );
}

MapaSP.propTypes = {
  onCidadeClick: PropTypes.func,
};
